import AboutUsComponent from "../../components/AboutUs/AboutUsComponent";
import Clients from "../../components/Clients/Clients";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/Hero Section/HeroSection";
import Navbar from "../../components/Navbar/Navbar";
import WhyNobel from "../../components/WhyNobelAI/WhyNobel";

const AboutUs = () => {
  return (
    <div id="AboutUs">
      <Navbar />
      <HeroSection variant={1} />
      <AboutUsComponent />
      <WhyNobel variant="top" />
      <Clients />
      <Footer />
    </div>
  );
};

export default AboutUs;
